import React, { Component } from 'react';
import PropTypes from 'prop-types';
import ParadigmaModal from "../../../components/ParadigmaModal/ParadigmaModal.js"
import api from "../../../api";



import { Label, Input, FormFeedback } from 'reactstrap';


class Edit extends Component {
    constructor(props) {
        super(props);
        this.state = {
        };
    }

    static propTypes = {
        onSubmit: PropTypes.func.isRequired,
        id: PropTypes.func.isRequired,
    }

    render() {
        return (
            <ParadigmaModal
                getUrl={api.proyectos.config.presupuesto.condiciones.edit}
                postUrl={api.proyectos.config.presupuesto.condiciones.edit}
                onSubmit={() => this.props.onSubmit()}
                id={this.props.id}
                missingIdMessage={"Debe seleccionar una fila."}
                successMessage={"La Moneda de Pago ha sido editada con éxito."}
                title={"Editar Moneda de Pago"}
                buttonTitle={"Editar Moneda de Pago"}
                buttonIcon={"fa fa-pencil fa-lg"}
                
                saveButton={true}
                closeButton={true}
                className={"ui-modal-dialog"}>
                <div className="ui-form">
                    <section className="ui-section-block">
                        <p className="ui-section-label">Datos de la moneda</p>
                        <div className="ui-row-1">
                            <div className="ui-field">
                                <Label>Nombre</Label>
                                <Input type="text" name="nombre" autoFocus data-auto-focus="true"></Input>
                                <FormFeedback className="col-12"></FormFeedback>
                            </div>
                        </div>
                    </section>
                </div>
            </ParadigmaModal>
        );
    }
}

export default Edit;



// WEBPACK FOOTER //
// ./src/views/ProyectosConfig/Presupuesto_Condiciones/Edit.js